import { useRef, useEffect } from 'react';

/**
 * Returns the value of its argument during the previous render. This can be
 * useful in `useEffect` hooks when you only want something to happen after a
 * specific property has changed. Returns `undefined` on the first render.
 *
 * https://usehooks.com/usePrevious/
 * https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 */
function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

export { usePrevious };
//# sourceMappingURL=use-previous.js.map
